import React from 'react';
import "./index.css";
import { vins } from "./data/Plats"

const VinsAffichage = (props) => {

    return (
        <div id={props.id} className="menus-content">
            <h1>{props.nom}</h1>
            <div className="menus__inside">
                <ul className="ul_carte">
                    {
                        vins.map((i) => {
                            return (
                                <>
                                    <h2> {i.titre} </h2>
                                    {
                                        i.items.map((item) => {
                                            return (
                                                <>
                                                    <h3>{item.sous_titre}</h3>
                                                    {
                                                        item.vin.map((vin, index) => {
                                                            if (!["50 cl", "25 cl", "1 verre"].includes(vin)) {
                                                                return (
                                                                    <li key={vin+index}><span>{vin}</span> <span className="dots"></span> <span className="vin_prix">{item.prix[index]}</span></li>
                                                                )
                                                            } else {
                                                                return (
                                                                    <li key={vin+index+"x"}><span>{vin}</span> <span className="dots"></span> <span className="carte_prix">{item.prix[index]}</span></li>
                                                                )
                                                            }
                                                        })
                                                    }
                                                </>
                                            )
                                        })
                                    }
                                </>
                            )
                        })
                    }

                </ul>
            </div>
        </div>
    );

};

export default VinsAffichage;